<div class="container">
  <div class="cause-list row">
    <div class="col-sm-3 col-6 col-lg-2 cause" *ngFor='let cause of causes'>
      <a *ngIf="!cause?.outer" [routerLink]="[cause.link]" [queryParams]="cause?.params" queryParamsHandling="merge">
        <div class="cause-bg" data-bg="/assets/images/homepage/causes-bg.png?w=auto">
          <div class="{{cause.class}} img-bg"></div>
          <span>{{ cause.text }}</span>
        </div>
      </a>
    </div>
  </div>
</div>